
export default [{
    path: '/supporters',
    component: () => import('./views/Supporter.vue'),
    meta: {
        requiresAuth: true,
    },
    children: [
        {
            path: '',
            name: 'supporters',
            component: () => import('./views/SupporterList.vue'),
        },
        {
            path: 'search',
            name: 'supporter-search-results',
            component: () => import('./views/SupporterSearchResults.vue'),
        },
        {
            path: ':id',
            name: 'supporter-view',
            component: () => import('./views/SupporterView.vue'),
        }
    ]
},];